import { ActionTypes as Type } from '../actions/favorite';

const appInitialState = {
  myOperatorId: 0,
  oppositeOperators: [],
  favorites: [],
  favorite: null,
  namePartial: '', // 一覧ーのフィルター
  refreshPage: false,
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'SUCCESS_API_GET_USER_INFO': {
      const userInfo = action.payload;
      const { operatorId: myOperatorId } = userInfo;
      return { ...state, myOperatorId };
    }
    case Type.SUCCESS_API_GET_OPERATORS: {
      const operators = action.payload.operators || [];
      const oppositeOperators = operators.filter(
        operator => operator.operatorId !== state.myOperatorId,
      );
      return { ...state, oppositeOperators };
    }
    case 'SUCCESS_API_GET_FAVORITES': {
      const { favorites } = action.payload;
      return { ...state, favorites };
    }
    case 'SUCCESS_API_CREATE_FAVORITE': {
      return { ...state, favorite: null, refreshPage: !state.refreshPage };
    }
    case 'SUCCESS_API_DELETE_FAVORITE': {
      return { ...state, favorite: null, refreshPage: !state.refreshPage };
    }
    case 'SUCCESS_API_UPDATE_FAVORITE': {
      return { ...state, favorite: null, refreshPage: !state.refreshPage };
    }
    case 'OPEN_FAVORITE_DIALOG': {
      const { id, name, operatorIds, groupId } = action.param;
      return {
        ...state,
        favorite: { id, name, operatorIds, groupId },
      };
    }
    case 'CLOSE_FAVORITE_DIALOG': {
      return { ...state, favorite: null };
    }
    case 'FILTER_FAVORITE_NAME': {
      const { namePartial } = action;
      return { ...state, namePartial };
    }
    case Type.INPUT_FAVORITE_NAME: {
      const { favoriteName } = action;
      return {
        ...state,
        favorite: {
          ...state.favorite,
          name: favoriteName,
        },
      };
    }
    case Type.CHECK_ALL_OPERATORS: {
      const { checked, filterIds } = action;
      let operatorIds = state.favorite.operatorIds.slice();
      if (checked) {
        const targetMembers = filterIds.filter(
          operatorId => !operatorIds.includes(operatorId),
        );
        operatorIds = operatorIds.concat(targetMembers);
      } else {
        operatorIds = operatorIds.filter(
          operatorId => !filterIds.includes(operatorId),
        );
      }
      return {
        ...state,
        favorite: {
          ...state.favorite,
          operatorIds,
        },
      };
    }
    case Type.RESET_CHECK_OPERATORS: {
      const { favorite } = state;
      return { ...state, favorite: { ...favorite, operatorIds: [] } };
    }
    case Type.CHECK_OPERATOR: {
      const { id } = action;
      const ids = state.favorite.operatorIds || [];
      const checkedIds = ids.slice();
      let newCheckedIds;
      if (checkedIds.some(operatorId => operatorId === id)) {
        // 選択肢から外す
        newCheckedIds = checkedIds.filter(operatorId => operatorId !== id);
      } else {
        // 選択肢に追加する
        newCheckedIds = checkedIds;
        newCheckedIds.push(id);
      }
      return {
        ...state,
        favorite: {
          ...state.favorite,
          operatorIds: newCheckedIds,
        },
      };
    }
    default:
      return state;
  }
};
